/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { TabPanel, TabView } from "primereact/tabview";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// @mui material components
import Grid from "@mui/material/Grid";

// Layouts
import UserDetails from "./user-details";
import UserRoles from "./user-roles";

import { getSubModulesByRoleId } from "../../store";

import Cookies from "universal-cookie";
import Components from "./components";

const cookies = new Cookies();

const NewAdminManagement = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let roleName = loginDetails.data.roleName;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let componentModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "5fc60000-a92b-4065-b676-2d535c3c2fbf",
  );
  let clientDetailsModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "f237efa9-3f56-4040-b2c9-32d34cf687ea",
  );
  let clientRolesModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "6d01ae38-4c16-4571-acb4-8b5eb9e76dcf",
  );

  // let userModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "428d1fae-c385-4576-8e00-77c60ec81ff2"
  // );
  // let userDetailsModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "8820f59d-7f44-4ddb-b251-d246cccc726b"
  // );
  // let viewAccessModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "df578bce-0f64-49c4-ab61-7be2d2d942bb"
  // );
  // let departmentAccess = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "52d9a4db-a3eb-4914-a623-f8cb1ae643fe"
  // );

  let tempUserModule = true;
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {componentModule && clientDetailsModule && clientRolesModule ? (
              <TabView>
                <TabPanel header="Components">
                  <Components />
                </TabPanel>
                <TabPanel header="Client Roles">
                  <UserRoles />
                </TabPanel>
                <TabPanel header="Client Details">
                  <UserDetails />
                </TabPanel>
              </TabView>
            ) : !componentModule && clientDetailsModule && clientRolesModule ? (
              <TabView>
                <TabPanel header="Client Roles">
                  <UserRoles />
                </TabPanel>
                <TabPanel header="Client Details">
                  <UserDetails />
                </TabPanel>
              </TabView>
            ) : componentModule && !clientDetailsModule && clientRolesModule ? (
              <TabView>
                <TabPanel header="Components">
                  <Components />
                </TabPanel>
                <TabPanel header="Client Roles">
                  <UserRoles />
                </TabPanel>
              </TabView>
            ) : componentModule && clientDetailsModule && !clientRolesModule ? (
              <TabView>
                <TabPanel header="Components">
                  <Components />
                </TabPanel>
                <TabPanel header="Client Details">
                  <UserDetails />
                </TabPanel>
              </TabView>
            ) : componentModule &&
              !clientDetailsModule &&
              !clientRolesModule ? (
              <TabView>
                <TabPanel header="Components">
                  <Components />
                </TabPanel>
              </TabView>
            ) : !componentModule &&
              !clientDetailsModule &&
              clientRolesModule ? (
              <TabView>
                <TabPanel header="Client Roles">
                  <UserRoles />
                </TabPanel>
              </TabView>
            ) : !componentModule &&
              clientDetailsModule &&
              !clientRolesModule ? (
              <TabView>
                <TabPanel header="Client Details">
                  <UserDetails />
                </TabPanel>
              </TabView>
            ) : // ) : (
            //   <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
            //     No Access
            //   </h4>
            // )}
            !componentModule && !clientDetailsModule && !clientRolesModule ? (
              <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
                No Access
              </h4>
            ) : null}
            {/* TabView for View Access (only for Admin) */}
            {/* {roleName === "admin" && (
      <TabView>
        <TabPanel header="View Access">
          <ViewAccess />
        </TabPanel>
      </TabView>
    )} */}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(NewAdminManagement);
